import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './LocationIconSelector.module.css';
import { importantPlaceIcons } from 'shared/utility';

const locationIconSelector = (props) => {
  return (
    <div className={classes.Container}>
      <FontAwesomeIcon className={classes.CloseIcon} onClick={props.close} icon="times" />
      <h2>Important Places</h2>
      <p>Select an icon</p>
      <div className={classes.LocationIconsContainer}>
        {importantPlaceIcons.map((icon, i) => (
          <div key={`icon-${i}`} className={classes.LocationIcon} onClick={() => props.clicked(icon.name)}>
            <icon.image fillColor="#01a2db" type="LocationIconSelector" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default locationIconSelector;
